export function inview() {
  $(function () {
    $(".js-fade-up").on("inview", function () {
      $(this).addClass("is-show");
    });
  });
}
